export default "__VITE_ASSET__muKD43Ch__"